import { Controller } from "stimulus"

const FACTOR =  1.35962;
export default class extends Controller {
    static targets = ["input", "select", "output"];
    
    connect() {
        if (this.select == 0) {
            this.input = this.output;
        } else {
            this.input = Math.round(this.output * FACTOR * 100) / 100;
        }
    }

    handleChange() {
        if (this.select == 0) {
            this.output = this.input;
        } else {
            this.output = Math.round(this.input / FACTOR * 100) / 100;
        }
    }

    get input() {
        return this.inputTarget.value;
    }
    set input(value) {
        this.inputTarget.value = value;
    }

    get select() {
        return this.selectTarget.value;
    }

    get output() {
        return this.outputTarget.value;
    }
    set output(value) {
        this.outputTarget.value = value;
    }
}